<template lang="html">
  <div>
    <br>
    <v-layout align-center justify-center>
      <v-flex xs12 lg8>

        <!-- Contatos do coordenador -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <div class="tituloSecao"
              v-if="administrador === true || usuarioPROEX === true || (projeto.funcao !== null && projeto.funcao.item === 1) || projeto.assessor === true">
              <label>Contatos do coordenador</label>
            </div>
          </v-flex>
        </v-layout>

        <div
          v-if="administrador === true || usuarioPROEX === true || (projeto.funcao !== null && projeto.funcao.item === 1) || projeto.assessor === true">
          <br>
        </div>

        <!-- E-mail -->
        <v-layout row
          v-if="administrador === true || usuarioPROEX === true || (projeto.funcao !== null && projeto.funcao.item === 1) || projeto.assessor === true">
          <v-flex xs12>
            <c-readonly-field readonly label="E-mail" :value="this.contatos.emailCoordenador || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row
          v-if="administrador === true || usuarioPROEX === true || (projeto.funcao !== null && projeto.funcao.item === 1) || projeto.assessor === true">
          <v-flex xs12>
            <c-readonly-field readonly label="Telefone"
              :value="this.contatos.telefoneCoordenador || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <div
          v-if="administrador === true || usuarioPROEX === true || (projeto.funcao !== null && projeto.funcao.item === 1) || projeto.assessor === true">
          <br>
        </div>

        <!-- Contatos da ação de extensão -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <div class="tituloSecao"
              v-if="administrador === true || usuarioPROEX === true || (projeto.funcao !== null && projeto.funcao.item === 1) || projeto.assessor === true">
              <label>Contatos da ação de extensão</label>
            </div>
          </v-flex>
        </v-layout>

        <div
          v-if="administrador === true || usuarioPROEX === true || (projeto.funcao !== null && projeto.funcao.item === 1) || projeto.assessor === true">
          <br>
        </div>

        <!-- Site -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field readonly label="Site" :value="this.contatos.site || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Instagram -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field readonly label="Instagram" :value="this.contatos.instagram || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Facebook -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field readonly label="Facebook" :value="this.contatos.facebook || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Youtube -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field readonly label="Youtube" :value="this.contatos.youtube || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Outras mídias sociais -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field-pre-format readonly label="Outras mídias sociais"
              :value="this.contatos.midiasSociais || '-'"></c-readonly-field-pre-format>
          </v-flex>
        </v-layout>

        <!-- Nome do contato -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field readonly label="Nome do contato"
              :value="this.contatos.nomeContato || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- E-mail -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field readonly label="E-mail" :value="this.contatos.email || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Telefone -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field readonly label="Telefone" :value="this.contatos.telefone || '-'"></c-readonly-field>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

    <c-card-footer :projeto="this.projeto" :extensao="this.extensao"
      :proxima="habilitaRelatorio() ? 'RelatoriosProjeto' : null" editar="EditarContatos" nome_editar="Editar"
      :habilitaBotaoGerarPDFAcao=true :habilitaBotaoFinalizarAcao=true>
    </c-card-footer>

  </div>
</template>

<script>
import CardFooter from '@/components/c-card-footer'
import ReadonlyField from '@/components/c-readonly-field'
import ReadonlyFieldPreFormat from '@/components/c-readonly-field-pre-format'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    contatos: {},
    dates: dates,
    formularioValido: false,
    observacoesRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 60 || 'Este campo não pode possuir mais que 60 caracteres'
    ]
  }),
  computed: {
    ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    // Verifica se a ação de extensão é um curso/oficina (antigo).
    acaoCursoOficina: function () {
      if (this.projeto.classificacaoSecundaria.id === 39729) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão é um curso.
    acaoCurso: function () {
      if (this.projeto.classificacaoSecundaria.id === 44194) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão é um oficina.
    acaoOficina: function () {
      if (this.projeto.classificacaoSecundaria.id === 44195) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão é um evento.
    acaoEvento: function () {
      if (this.projeto.classificacaoSecundaria.id === 39730) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o tipo de ação de extensão está habilitado a ter a aba Relatórios.
    tipoAcaoExtensaoHabilitado: function () {
      if (this.acaoCursoOficina() || this.acaoCurso() || this.acaoOficina() || this.acaoEvento()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function () {
      if (this.projeto.situacao.item === 18) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function () {
      if (this.projeto.situacao.item === 20) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Relatório aguardando aprovação".
    situacaoRelatorioAguardandoAprovacao: function () {
      if (this.projeto.situacao.item === 22) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Concluído".
    situacaoConcluido: function () {
      if (this.projeto.situacao.item === 19) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Cancelado".
    situacaoCancelado: function () {
      if (this.projeto.situacao.item === 5) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a situação da ação de extensão está habilitada a ter a aba Relatórios.
    situacaoAcaoExtensaoHabilitado: function () {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio() || this.situacaoRelatorioAguardandoAprovacao() || this.situacaoConcluido() || this.situacaoCancelado()) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é administrador.
    usuarioAdministrador: function () {
      if (this.administrador === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function () {
      if ((this.projeto.funcao != null && this.projeto.funcao.item === 1)) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function () {
      if (this.projeto.assessor === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é usuário Proex.
    usuarioProex: function () {
      if (this.usuarioPROEX === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado está habilitado para a aba Relatórios.
    usuarioHabilitado: function () {
      if (this.usuarioAdministrador() || this.usuarioCoordenador() || this.usuarioAssessor() || this.usuarioProex()) {
        return true
      } else {
        return false
      }
    },
    habilitaRelatorio: function () {
      if (this.tipoAcaoExtensaoHabilitado() && this.situacaoAcaoExtensaoHabilitado()) {
        return true
      } else {
        return false
      }
    }
  },
  mounted: function () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' })
    projetos.getContatosDoProjeto(this.idProjeto)
      .then(response => {
        this.contatos = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando contatos.' })
      })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter,
    'c-readonly-field': ReadonlyField,
    'c-readonly-field-pre-format': ReadonlyFieldPreFormat
  }
}
</script>

<style lang="css">
#v-card-title_label {
  font-size: 12pt;
}

.tituloSecao {
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// projeto-contatos.vue?457ba579